import { forwardRef } from 'react'
import clsx from 'clsx'

import { RadioButtonProps } from './RadioButton.types'

export const RadioButton = forwardRef<HTMLInputElement, RadioButtonProps>(
  (props, ref) => {
    const {
      name,
      checked,
      className,
      disabled,
      isInvalid,
      id,
      label,
      onChange,
      value,
    } = props

    const classNames = clsx(
      'RadioButton',
      disabled && 'RadioButton-disabled',
      isInvalid && 'RadioButton-is-invalid',
      className,
    )

    return (
      <label className={classNames} htmlFor={id}>
        <input
          ref={ref}
          checked={checked}
          disabled={disabled}
          id={id}
          name={name}
          onChange={onChange}
          type="radio"
          value={value}
        />
        {label}
      </label>
    )
  },
)
